import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "3-19",
  "description": "Yoga Sutra Chapter 3, Verse 19"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "-3-19--"
    }}><a parentName="h3" {...{
        "href": "/Chapter-3/3-18/"
      }}>{`<`}</a>{` 3-19 `}{` `}<a parentName="h3" {...{
        "href": "/Chapter-3/3-20/"
      }}>{`>`}</a></h3>
    <h1 {...{
      "id": "pratyasya-para-citta-jñānam"
    }}>{`pratyasya para-citta-jñānam`}</h1>
    <h4 {...{
      "id": "of-psychic-activity-knowledge-of-others-psyche"
    }}>{`Of psychic activity, knowledge of others psyche`}</h4>
    <br />
    <p><strong parentName="p">{`pratyaya`}</strong>{` - psychic activity; cause; conception, assumption, notion, idea;`}</p>
    <p><strong parentName="p">{`para`}</strong>{` - higher, other`}</p>
    <p><strong parentName="p">{`citta`}</strong>{` - psyche (the totality of the human mind, conscious and unconscious); mind; heart`}</p>
    <p><strong parentName="p">{`jñāna`}</strong>{` - knowing; knowledge; higher knowledge`}</p>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      